const folderList = [
  {id: 121, name: 'All', alias: 'all', icon: 'user'},
  {id: 122, name: 'Frequent', alias: 'frequent', icon: 'star'},
  {id: 124, name: 'Starred', alias: 'starred', icon: 'star'},
];
export default folderList;
